import React, { useMemo } from 'react'
import { makeStyles } from '@mui/styles'
import lang from '@/lang'
import { SelectInput } from '@/modules/base/components/inputs'
import { QUARTERLY, MONTHLY } from './constants'
import RichTooltip from '@/modules/base/components/rich-tooltip/rich-tooltip'

const useStyles = makeStyles((theme) => ({
  contentWrapper: {
    width: '100%',
  },
  vatReturnInput: {
    width: '100%',
  },
  tooltipWrapper: {
    height: 'fit-content',
    color: theme.black,
  },
  tooltipTitle: {
    paddingBottom: '20px',
    textAlign: 'center',
    fontSize: theme.fontSizes.default,
    lineHeight: '20px',
    color: theme.black,
    fontWeight: theme.fontWeights.bold,
  },
  tooltipContent: {
    fontSize: theme.fontSizes.smaller,
    marginTop: 10,
    '&:last-of-type': {
      fontWeight: theme.fontWeights.bold,
    },
  },
}))

const VatReturnInput = ({ readOnly }) => {
  const classes = useStyles()
  const options = [{ value: MONTHLY, label: 'Monatlich' }, { value: QUARTERLY, label: 'Quartalsweise' }]

  const tooltipContent = useMemo(() => (<div className={classes.tooltipWrapper}>
    <div className={classes.tooltipTitle}>{lang.settings.taxes.vatReturnInputTooltipHeader}</div>
    <div className={classes.tooltipContent}>{lang.settings.taxes.vatReturnInputTooltipDescription1}</div>
    <div className={classes.tooltipContent}>{lang.settings.taxes.vatReturnInputTooltipDescription2}</div>
  </div>
  ), [])

  return (
    <>
      <RichTooltip content={tooltipContent} width={360} placement={'top'}>
        <div className={classes.contentWrapper}>
          <SelectInput
            name='vatReturnPeriods'
            className={classes.vatReturnInput}
            useFormik
            notAsync
            allowCreate={false}
            label={lang.settings.taxes.vatReturnInput}
            options={options}
            customSelectOptions={{
              placeholder: lang.settings.taxes.vatReturnInputPlaceholder,
            }}
            readOnly={readOnly}
          />
        </div>
      </RichTooltip>
    </>
  )
}

export default VatReturnInput
